import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { useNavigate, useParams } from 'react-router-dom'
const CreateModal = ({ handleRefresh, category }) => {
  const uploadImage = useUploadImage()
  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const params = useParams()
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }
  console.log(params, 'params121212')


  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      name: e.target.name.value,
      description: e.target.description.value,
      type: params.type,
      status: e.target.status.value,
      instruction: e.target.instruction.value,
      points: e.target.points.value,
      category: params.page_id,
    }
    console.log(payload, "payloadpayload ")

    const { response } = await AppService.checklist.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const handleCsvUpload = async (e) => {
    e.preventDefault()
    const fileInput = e.target
    const file = fileInput.files[0]

    if (!file) {
      alert('Please select a file')
      return
    }

    const formData = new FormData()
    formData.append('csvFile', file)
    formData.append('agency_id', agency._id)

    setProcessing(true)
    const response = await AppService.checklist.uploadCsv({ payload: formData })

    if (response) {
      fileInput.value = '' // Reset file input
      alert('CSV uploaded successfully!') // Show success alert
      handleRefresh()
    }

    setProcessing(false)
  }

  // const handleCsvUpload = async (e) => {
  //   e.preventDefault();
  //   const file = e.target.files[0];
  //   if (!file) {
  //     alert("Please select a file");
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append("csvFile", file);
  //   formData.append("agency_id", agency._id);
  //   const payload = formData;
  //   const response = await AppService.checklist.uploadCsv({ payload });
  //   if (response) {
  //     onClose();
  //     handleRefresh();
  //   }
  // };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
        <MDButton color="white" variant="contained" onClick={handleModal}>
          Create
        </MDButton>
        <input
          type="file"
          accept=".csv"
          onChange={handleCsvUpload}
          style={{ display: 'none' }}
          id="csv-upload"
        />
        <label htmlFor="csv-upload">
          <MDButton color="white" variant="contained" component="span" disabled={processing}>
            Upload CSV
          </MDButton>
        </label>
      </div>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Check list
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput select name="category" fullWidth required SelectProps={{ native: true }}>
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <MDInput label="Description" name="description" fullWidth required />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput select name="type" fullWidth required SelectProps={{ native: true }}>
                <option value="location">Location</option>
                <option value="agency">Agency</option>
                <option value="levelupmarketplace">LevelUpMarketplace</option>
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Instruction</MDTypography>
              <MDInput label="Instruction" name="instruction" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput label="Point Number" name="points" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}>
                <option value="Draft">Draft</option>
                <option value="Publish">Publish</option>
              </MDInput>
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
